import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core';
import { provideRouter } from '@angular/router';

import { routes } from './app.routes';
import { provideHttpClient, withFetch, withInterceptors } from '@angular/common/http';
import { authInterceptor } from './common/api.interceptor';
import { environment } from '../environments/environment';
import { provideVersusClientClient } from './api';

export const appConfig: ApplicationConfig = {
  providers: [
     provideZoneChangeDetection({ eventCoalescing: true }),
     provideRouter(routes),
     provideHttpClient(withFetch(),withInterceptors([authInterceptor])),
     provideVersusClientClient({
      basePath:environment.apiBaseUrl
     })
    
    ]
};
